<template>
  <div class="container-fluid">
    <div class="animated fadeIn">
      <div class="row mt-3">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-header">
              <div class="row">
                <div class="col-12 text-center">
                  <label><strong @dblclick="vModel.isOutDated = !vModel.isOutDated">{{ customer.companyName }}
                      {{ vModel.isOutDated ? "--" : "" }}</strong></label>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-3">
                  <label>Adress</label>
                  <select v-model="vModel.deliveryAddressFK" class="form-control form-control-sm">
                    <option v-for="option in customer.addresses" :key="option.id" :value="option.id">
                      {{ option.name }}
                    </option>
                  </select>
                </div>
                <div class="col-3">
                  <label>Leveransdatum</label>
                  <VueCtkDateTimePicker :no-button-now="true" format="YYYY-MM-DD HH:mm" formatted="YYYY-MM-DD HH:mm"
                    class="deliveryDate form-control form-control-sm" :no-label="true" locale="sv"
                    v-model="vModel.deliveryDate" />
                </div>
                <div class="col-2">
                  <label>Leveranssätt</label>
                  <select v-model.number="vModel.deliveryMode" class="form-control form-control-sm" id="deliveryMode">
                    <option :value="deliveryModeEnum.value" v-for="deliveryModeEnum in $beplugins.GetEnumsByType(
                      'DeliveryModeEnums'
                    )" :key="deliveryModeEnum.label">
                      {{ $t(`enums.${deliveryModeEnum.label}`) }}
                    </option>
                  </select>
                </div>
                <div class="col-2">
                  <label>Status</label>
                  <select v-model.number="vModel.orderStatus" class="form-control form-control-sm" id="deliveryMode">
                    <option :value="orderStatusEnum.value" v-for="orderStatusEnum in $beplugins.GetEnumsByType(
                      'OrderStatusEnums'
                    ).filter(x => x.value !== 6)" :key="orderStatusEnum.label">
                      {{ $t(`enums.${orderStatusEnum.label}`) }}
                    </option>
                  </select>
                </div>
                <div class="col-2">
                  <label>Betalning</label>
                  <select v-model.number="vModel.paymentStatus" class="form-control form-control-sm" id="deliveryMode">
                    <option :value="paymentStatusEnum.value" v-for="paymentStatusEnum in $beplugins.GetEnumsByType(
                      'PaymentStatusEnums'
                    )" :key="paymentStatusEnum.label">
                      {{ $t(`enums.${paymentStatusEnum.label}`) }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-1">
                  <label>Artikelnr</label>
                </div>
                <div class="col-3">
                  <label>Produkt</label>
                </div>
                <div class="col-1">
                  <label>Saldo</label>
                </div>
                <div class="col-1">
                  <label>Enhet</label>
                </div>
                <div class="col-1">
                  <label>Antal</label>
                </div>
                <div class="col-1">
                  <label>Inpris</label>
                </div>
                <div class="col-1">
                  <label>À-pris</label>
                </div>
                <div class="col-1">
                  <label>Pris</label>
                </div>
                <div class="col-1">
                  <label>TG</label>
                </div>
                <div class="col-1"></div>
              </div>
              <div class="row" :style="`background: ${item.incomingPrice > item.price
                  ? 'red; padding-top:10px;'
                  : ''
                }`
                " v-for="(item, itemIndex) in vModel.products" :key="`order-item-${itemIndex}`">
                <div class="col-1">
                  <label class="form-control form-control-sm">{{
                    item.productNumber
                  }}</label>
                </div>
                <div class="col-3">
                  <div class="row">
                    <div class="col-11">
                      <v-select class="product-select" :ref="`product-select-${itemIndex}`" :clearable="false"
                        placeholder="sök..." :options="GetProducts" label="name" :value="item.name" @input="(product) =>
                            $beplugins.OrderProductSelected(
                              vModel,
                              product,
                              itemIndex,
                              $refs
                            )
                          " :filter-by="$beplugins.OrderProductFilter">
                        <div slot="no-options">hittar ingen data!</div>
                        <template v-slot:option="option">
                          <div class="row" :style="`background: ${customer.customer_Products.findIndex(
                            (x) => x.productId === option.id
                          ) !== -1 &&
                              option.id !==
                              '00000000-0000-0000-0000-000000000000'
                              ? '#FBB13C'
                              : ''
                            }`
                            ">
                            <div class="col-12">
                              {{ option.name }}
                              <span v-if="customer.customer_Products.findIndex(
                                (x) => x.productId === option.id
                              ) !== -1 &&
                                option.id !==
                                '00000000-0000-0000-0000-000000000000'
                                " class="fa fa-star pull-right" style="color: #2a1ab9; margin-top:3px"></span>
                            </div>
                          </div>
                        </template>
                      </v-select>
                    </div>
                    <div class="col-1 text-left">
                      <a v-if="customer.customer_Products.findIndex(
                        (x) => x.productId === item.productFK
                      ) === -1 &&
                        item.productFK !==
                        '00000000-0000-0000-0000-000000000000'
                        " @click="CreateAsFavorite(item.productFK, true)" href="javascript:void(0)">
                        <i class="fa fa-star-o" style="color: #2a1ab9;"></i>
                      </a>
                      <a v-else-if="customer.customer_Products.findIndex(
                        (x) => x.productId === item.productFK
                      ) !== -1 &&
                        item.productFK !==
                        '00000000-0000-0000-0000-000000000000'
                        " @click="CreateAsFavorite(item.productFK, false)" href="javascript:void(0)">
                        <i class="fa fa-star" style="color: #2a1ab9;"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="col-1">
                  <label class="form-control form-control-sm text-center">{{
                    item.inStock
                  }}</label>
                </div>
                <div class="col-1">
                  <select @keydown.enter="
                    $beplugins.OrderUnitSelected(
                      products,
                      item,
                      itemIndex,
                      $refs
                    )
                    " @change="
    $beplugins.OrderUnitSelected(
      products,
      item,
      itemIndex,
      $refs
    )
    " :ref="`unit-select-${itemIndex}`" v-model="item.unit" class="form-control form-control-sm">
                    <option :value="unitEnum.value" v-for="unitEnum in $beplugins.GetEnumsByType('UnitEnums')"
                      :key="unitEnum.label">
                      {{ $t(`enums.${unitEnum.label}`) }}
                    </option>
                  </select>
                </div>
                <div class="col-1">
                  <input :ref="`quntity-amount-${itemIndex}`" @keyup="$beplugins.InputValidatorMoney(item, 'quantity')"
                    @keydown.enter="CreateNewRow(item)" v-model="item.quantity" @change="
                      $beplugins.OrderQuantityChanged(
                        products,
                        item,
                        itemIndex,
                        $refs
                      )
                      " class="form-control form-control-sm text-center" type="text" />
                </div>
                <div class="col-1">
                  <input type="text" readonly v-model="item.incomingPrice" class="form-control form-control-sm float-left"
                    style="width: 80px; background: #fff" />
                </div>
                <div class="col-1">
                  <input @keyup="$beplugins.InputValidatorMoney(item, 'price')" type="text"
                    :ref="`price-amount-${itemIndex}`" @keydown.enter="CreateNewRow(item)" v-model="item.price"
                    class="form-control form-control-sm float-left" style="width: 80px" />
                </div>
                <div class="col-1">
                  <label class="form-control form-control-sm text-right">
                    {{ item.price * item.pieces }}</label>
                </div>
                <div class="col-1">
                  <label class="form-control form-control-sm text-right">{{
                    $beplugins.CalculateTG(item.price, item.incomingPrice)
                  }}
                    %</label>
                </div>
                <div class="col-1 text-center">
                  <div class="btn-group pull-right" role="group" aria-label="Basic example">
                    <button type="button" :disabled="vModel.products.length < 2" class="btn btn-primary btn-sm"
                      @click="vModel.products.splice(itemIndex, 1)">
                      <i class="fa fa-trash"></i>
                    </button>
                    <button type="button" class="btn btn-primary btn-sm" @click="
                      $beplugins.OrderInsertProduct(
                        vModel,
                        $nextTick,
                        false,
                        []
                      )
                      ">
                      <i class="fa fa-plus"></i>
                    </button>
                  </div>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-3 text-center">
                  <strong>TB
                    {{
                      $beplugins.CalculateTB(
                        $beplugins.TotalPriceOrderViewModelItem(vModel, false),
                        $beplugins.TotalIncomingPriceOrderViewModelItem(
                          vModel,
                          false
                        )
                      )
                    }}
                    {{ customer.currency }}</strong>
                </div>
                <div class="col-3 text-center">
                  <strong>TG
                    {{
                      $beplugins.CalculateTG(
                        $beplugins.TotalPriceOrderViewModelItem(vModel, false),
                        $beplugins.TotalIncomingPriceOrderViewModelItem(
                          vModel,
                          false
                        )
                      )
                    }}
                    %</strong>
                </div>
                <div class="col-3 text-center">
                  <strong>exkl. moms
                    {{
                      $beplugins.TotalPriceOrderViewModelItem(vModel, false)
                      | money
                    }}
                    {{ customer.currency }}</strong>
                </div>
                <div class="col-3 text-center">
                  <strong>inkl. moms
                    {{
                      $beplugins.TotalPriceOrderViewModelItem(vModel, true)
                      | money
                    }}
                    {{ customer.currency }}</strong>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-12">
                  <label>Kommentar</label>
                  <textarea v-model="vModel.notes" rows="4" class="form-control form-control-sm"></textarea>
                </div>
                <div class="col-12 mt-3">
                  <button @click="BeforeCreateOrder(false)" :disabled="vModel.products.filter((x) => x.productNumber).length ===
                    0
                    " type="button" class="btn btn-sm btn-success pull-right">
                    Spara
                  </button>
                  <button :disabled="vModel.products.filter((x) => x.productNumber).length ===
                    0
                    " @click="$modal.show('order-preview')" type="button" class="btn btn-sm btn-primary pull-right mr-3">
                    Förhandsgranska
                  </button>
                  <button @click="$beplugins.CloseWindowConfirmation('Avbryt order?')" type="button"
                    class="btn btn-sm btn-danger pull-right mr-3">
                    Avbryt
                  </button>
                </div>
                <div class="col-12">
                  <OrderedCustomerProductList :productList="orderedProducts" />
                </div>
              </div>
            </div>
            <loading :active.sync="isLoading" :color="'#FC6534'" :is-full-page="true"></loading>
          </div>
        </div>
      </div>
    </div>
    <modal v-if="!isLoading" name="askProduct-preview" :draggable="true" :clickToClose="false" :height="'auto'"
      :width="'90%'" :scrollable="true" :transition="'fade'">
      <div class="card">
        <div class="card-body">
          <div class="row mb-4">
            <div class="col-sm-4">
              <h6 class="mb-3">Merförsäljning:</h6>
            </div>
          </div>
          <div class="table-responsive-sm">
            <table class="table table-sm table-striped table-hover">
              <thead>
                <tr>
                  <th>Fråga om följande produkter</th>
                  <th class="text-center">Rate</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, rowIndex) in askProductWeek" :key="`week-${row.productNumber}-${rowIndex}`"
                  :index="rowIndex">
                  <td>{{ row.productName }} {{ row.productNumber }}</td>
                  <td class="text-center">{{ row.rate }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="container-fluid py-3">
        <div class="row">
          <div class="col-12">
            <button @click="CreateOrder(tempIsPrint)" type="button" class="btn btn-sm btn-primary pull-right mr-3">
              Spara
            </button>
            <button @click="$modal.hide('askProduct-preview')" type="button"
              class="btn btn-sm btn-danger pull-right mr-3">
              Avbryt
            </button>
          </div>
        </div>
      </div>
    </modal>
    <modal v-if="!isLoading" name="order-preview" :draggable="true" :clickToClose="false" :height="'auto'" :width="'90%'"
      :scrollable="true" :transition="'fade'">
      <div class="card">
        <div class="card-body">
          <div class="row mb-4">
            <div class="col-sm-4">
              <h6 class="mb-3">Kund:</h6>
              <div>
                <strong>{{ customer.companyName }}</strong>
              </div>
              <div>
                {{
                  `${GetDeliveryAddress.address
                    ? GetDeliveryAddress.address + ","
                    : ""
                  }, ${GetDeliveryAddress.postalCode
                    ? GetDeliveryAddress.postalCode + ","
                    : ""
                  } ${GetDeliveryAddress.city ? GetDeliveryAddress.city + "," : ""
                  }, ${GetDeliveryAddress.country
                    ? GetDeliveryAddress.country + ","
                    : ""
                  }`
                }}
              </div>
              <div>E-post: {{ customer.email }}</div>
              <div>Telefon: {{ customer.phone }}</div>
            </div>

            <div class="col-sm-4"></div>

            <div class="col-sm-4">
              <h6 class="mb-3">Leverans & Status:</h6>
              <div>
                Status:
                <strong>{{
                  $t(
                    `enums.${$beplugins.GetEnumsByValue(
                      "OrderStatusEnums",
                      vModel.orderStatus
                    )}`
                  )
                }}</strong>
              </div>
              <div>
                Leveranssätt
                <strong>{{
                  $t(
                    `enums.${$beplugins.GetEnumsByValue(
                      "DeliveryModeEnums",
                      vModel.deliveryMode
                    )}`
                  )
                }}</strong>
              </div>
              <div>
                Leveransdatum
                <strong>{{ vModel.deliveryDate }}</strong>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4 col-sm-5" style="font-weight: bold">
              Kommentar: <br />
              {{ vModel.notes }}
            </div>
          </div>
          <div class="table-responsive-sm">
            <table class="table table-sm table-striped table-hover">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Artikelnr</th>
                  <th>Produkt</th>
                  <th class="text-center">Saldo</th>
                  <th>Enhet</th>
                  <th class="text-center">Antal</th>
                  <th class="text-center">Inpris</th>
                  <th class="text-center">À-pris</th>
                  <th class="text-center">Pris</th>
                  <th class="text-center">TG</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, rowIndex) in vModel.products.filter(
                  (x) => x.productNumber
                )" :key="`${row.productNumber}-${row.name}-${rowIndex}`" :index="rowIndex">
                  <td>{{ ++rowIndex }}</td>
                  <td>{{ row.productNumber }}</td>
                  <td>{{ row.name }}</td>
                  <td class="text-center">{{ row.inStock }}</td>
                  <td>
                    {{
                      $t(
                        `enums.${$beplugins.GetEnumsByValue(
                          "UnitEnums",
                          row.unit
                        )}`
                      )
                    }}
                  </td>
                  <td class="text-center">{{ row.quantity }}</td>
                  <td class="text-center">{{ row.incomingPrice }}</td>
                  <td class="text-center">
                    {{ row.price }}
                    <span class="ml-2">{{ customer.currency }}</span>
                  </td>
                  <td class="text-center">
                    {{ (row.price * row.pieces) | money }}
                    {{ customer.currency }}
                  </td>
                  <td class="text-center">
                    {{ $beplugins.CalculateTG(row.price, row.incomingPrice) }} %
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="4">
                    <strong>Antal rader:
                      {{
                        vModel.products.filter((x) => x.productNumber).length
                      }}</strong>
                  </td>
                  <td>
                    <strong>TB
                      {{
                        $beplugins.CalculateTB(
                          $beplugins.TotalPriceOrderViewModelItem(
                            vModel,
                            false
                          ),
                          $beplugins.TotalIncomingPriceOrderViewModelItem(
                            vModel,
                            false
                          )
                        )
                      }}
                      {{ customer.currency }}</strong>
                  </td>
                  <td>
                    <strong>TG
                      {{
                        $beplugins.CalculateTG(
                          $beplugins.TotalPriceOrderViewModelItem(
                            vModel,
                            false
                          ),
                          $beplugins.TotalIncomingPriceOrderViewModelItem(
                            vModel,
                            false
                          )
                        )
                      }}
                      %</strong>
                  </td>
                  <td colspan="2">
                    <strong>exkl. moms
                      {{
                        $beplugins.TotalPriceOrderViewModelItem(vModel, false)
                        | money
                      }}
                      {{ customer.currency }}</strong>
                  </td>
                  <td colspan="2">
                    <strong>inkl. moms
                      {{
                        $beplugins.TotalPriceOrderViewModelItem(vModel, true)
                        | money
                      }}
                      {{ customer.currency }}</strong>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      <div class="container-fluid py-3">
        <div class="row">
          <div class="col-12">
            <button type="button" @click="BeforeCreateOrder(true)" class="btn btn-sm btn-success pull-right">
              Skriv ut
            </button>
            <button @click="BeforeCreateOrder(false)" type="button" class="btn btn-sm btn-primary pull-right mr-3">
              Spara
            </button>
            <button @click="$modal.hide('order-preview')" type="button" class="btn btn-sm btn-danger pull-right mr-3">
              Avbryt
            </button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>
<script lang="ts">
import { Component, Vue, Watch } from "vue-property-decorator";
import {
  CustomerEntity,
  DeliveryAddressEntity,
  ProductEntity,
  OrderEntity,
  OrderProductEntity,
  Join_PriceTemplate_Product,
  Join_Customer_Product,
  CompanyDetails,
  OrderStatusEnums,
  ProductStatusEnums,
  OrderProductDTO,
  AskProductResponse,
} from "@/services/api/ApiGeneral";
import { apiGeneral } from "@/services/api/ApiServices";
import Loading from "vue-loading-overlay";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import vSelect from "vue-select";
import Moment from "moment";
import OrderedCustomerProductList from "@/components/orders/OrderedCustomerProductList.vue";
const moment = Moment;
@Component({
  components: {
    Loading,
    VueCtkDateTimePicker,
    vSelect,
    OrderedCustomerProductList,
  },
})
export default class NewOrder extends Vue {
  private tempIsPrint = false;
  private settings: CompanyDetails = new CompanyDetails();
  private products: ProductEntity[] = [];
  private orderedProducts: OrderProductDTO[] = [];
  private isLoading: boolean = true;
  private vModel: OrderEntity = new OrderEntity({
    customerMode: 0,
    deliveryMode: 1,
    orderStatus: 0,
    paymentStatus: 0,
    isLocked: false,
    orderId: "",
    id: "00000000-0000-0000-0000-000000000000",
    sellerFK: "",
    customerFK: "",
    sellerAlias: "",
    deliveryAddressFK: "",
    notes: "",
    products: [],
    deliveryDate: moment().format("YYYY-MM-DD HH:mm"),
    createdDate: moment().format("YYYY-MM-DD HH:mm"),
    createdBy: "",
    customer: undefined,
    totalWeight: 0,
    selectedForPrint: false,
    printedDeliveryNote: false,
    printedPickList: false,
    isOutDated: false,
  });
  private customer: CustomerEntity = new CustomerEntity();
  private askProductResponse = new AskProductResponse();
  get GetProducts() {
    return this.products.filter((x) => x.status === ProductStatusEnums.Active);
  }
  get GetDeliveryAddress() {
    const itemIndex = this.customer!.addresses!.findIndex(
      (x) => x.id === this.vModel.deliveryAddressFK
    );
    if (itemIndex !== -1) {
      return this.customer.addresses![itemIndex];
    } else {
      return new DeliveryAddressEntity();
    }
  }
  get askProductWeek() {
    return this.askProductResponse.weekProducts?.filter((p) => {
      const items = this.vModel.products?.filter((x) => x.productFK === p.productFk);
      if (items && items.length > 0) {
        return false;
      }
      return true;
    });
  }
  private async created() {
    this.vModel.deliveryDate = Moment(new Date()).format("YYYY-MM-DD");

    const tempSettings = await apiGeneral.companyDetail_Get();
    if (tempSettings) {
      this.settings = tempSettings;
      await this.LoadData();
    }
    this.isLoading = false;
  }
  private mounted() {
    window.setTimeout(() => {
      const el = document.getElementsByClassName("vs__search");
      (el[0] as any).focus();
    }, 1000);
  }
  private CreateNewRow(payload: OrderProductEntity) {
    const productIndex = this.customer.priceTemplate!.priceTemplate_Products?.findIndex(
      (x) => x.productId === payload.productFK
    )!;
    const priceTemplateId = this.customer.priceTemplate!.id;
    const originalPrice =
      productIndex !== -1
        ? this.customer.priceTemplate!.priceTemplate_Products![productIndex]
          .price
        : 0;
    // const newPrice = payload.unit === UnitEnums.Carton ? payload.price / payload.pieces : payload.price;
    const newPrice = payload.price;
    if (
      newPrice < payload.lastPrice &&
      !confirm(`Du gör en förlust på angivet pris, vill du fortsätta?`)
    ) {
      return;
    }
    if (newPrice !== originalPrice) {
      this.$swal({
        icon: "warning",
        title: "Är du säker?",
        text: `Vill du uppdatera priset?`,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ja",
        cancelButtonText: "Nej",
      }).then(async (result: any) => {
        if (result.value) {
          await apiGeneral
            .priceTemplate_UpdatePrice(
              priceTemplateId,
              payload.productFK,
              newPrice
            )
            .then((response) => {
              if (response.isSuccess && response.messages != null) {
                if (productIndex !== -1) {
                  this.customer.priceTemplate!.priceTemplate_Products![
                    productIndex
                  ].price = newPrice;
                } else {
                  this.customer.priceTemplate!.priceTemplate_Products!.push(
                    new Join_PriceTemplate_Product({
                      price: newPrice,
                      productId: payload.productFK,
                      priceTemplateId: priceTemplateId,
                    })
                  );
                }
                const productListIndex = this.products.findIndex(
                  (x) => x.id === payload.productFK
                );
                if (productListIndex !== -1) {
                  this.products[productListIndex].price = newPrice;
                }
                this.$beplugins.ApiSuccess(response);
              } else {
                this.$beplugins.ApiError(response);
              }
            });
        }
      });
    }
    this.$beplugins.OrderInsertProduct(
      this.vModel,
      this.$nextTick,
      false,
      [],
      this.$refs
    );
  }
  private async LoadData() {
    this.askProductResponse = await apiGeneral.smartOrder_AskProductsForCustomer(this.$route.params.id);
    await apiGeneral
      .customer_GetById(this.$route.params.id, true, true, true, true)
      .then((response) => {
        this.customer = response;
        this.vModel.sellerAlias = this.$beplugins.GetOidcUser().name;
        this.vModel.sellerFK = this.$beplugins.GetOidcUser().sub;
        this.vModel.currency = this.customer.currency;
        if (this.customer.addresses!.length > 1) {
          const defaultAddressList = this.customer.addresses?.filter((x) => x.isDefault);
          if (defaultAddressList!.length > 0) {
            this.vModel.deliveryAddressFK = defaultAddressList![0].id;
          } else {
            this.vModel.deliveryAddressFK = this.customer.addresses![0].id;
          }
        } else {
          this.vModel.deliveryAddressFK = this.customer.addresses![0].id;
        }
        this.vModel.createdBy = `${this.$beplugins.GetOidcUser().name} - ${this.$beplugins.GetOidcUser().email
          }`;
        this.vModel.customerFK = this.customer.id;
        this.$beplugins.OrderInsertProduct(
          this.vModel,
          this.$nextTick,
          false,
          [],
          this.$refs
        );
      })
      .then(
        async () =>
          await apiGeneral.product_GetAll().then((products) => {
            this.products = products;
            this.customer.priceTemplate!.priceTemplate_Products!.forEach(
              (pp) => {
                const productIndex = this.products.findIndex(
                  (x) => x.id === pp.product!.id
                );
                if (productIndex !== -1) {
                  this.products[productIndex].price = pp.price;
                }
              }
            );
            this.products.forEach((p) => {
              if (p.price === 0) {
                p.price = p.priceBase;
              }
            });
          })
      );
    this.orderedProducts = await apiGeneral.orderProduct_GetAllOrderedProductsByCustomerId(
      this.$route.params.id
    );

  }
  private async BeforeCreateOrder(isPrint: boolean) {
    this.tempIsPrint = isPrint;
    if (this.askProductWeek && this.askProductWeek.length > 0) {
      this.$modal.show('askProduct-preview');
    } else {
      await this.CreateOrder(isPrint);
    }
  }
  private async CreateOrder(isPrint: boolean) {
    this.$modal.hide('askProduct-preview')
    this.vModel.createdDate = moment().format("YYYY-MM-DD HH:mm");
    this.isLoading = true;
    this.vModel.products = this.vModel.products!.filter(
      (x) => x.productFK !== "00000000-0000-0000-0000-000000000000"
    );
    if (!this.vModel.printedPickList && isPrint) {
      this.vModel.printedPickList = true;
    } else if (!this.vModel.printedDeliveryNote && isPrint) {
      this.vModel.printedDeliveryNote = true;
      this.vModel.orderStatus = OrderStatusEnums.Transit;
    }
    await apiGeneral
      .order_Create(this.vModel)
      .then(async (response) => {
        if (response.isSuccess && response.messages != null) {
          if (isPrint) {
            this.vModel.customer = this.customer;
            if (
              this.vModel.printedPickList &&
              !this.vModel.printedDeliveryNote
            ) {
              await this.$beplugins.PrintingPickList(
                [this.vModel],
              );
            } else {
              await this.$beplugins.PrintingDeliveryNote(
                [this.vModel],
              );
            }
          }
          window.close();
        } else {
          this.$beplugins.ApiError(response);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    this.isLoading = false;
  }
  private async CreateAsFavorite(productId: string, isFavorite: boolean) {
    this.isLoading = true;
    await apiGeneral
      .product_ToogleCustomerFavorite(this.customer.id, productId, isFavorite)
      .then((response) => {
        if (response.isSuccess && response.messages != null) {
          if (isFavorite) {
            this.customer.customer_Products?.push(
              new Join_Customer_Product({
                isFavorite: true,
                customerId: this.customer.id,
                productId: productId,
              })
            );
          } else {
            const itemIndex = this.customer.customer_Products?.findIndex(
              (x) =>
                x.customerId === this.customer.id && x.productId === productId
            );
            if (itemIndex !== -1) {
              this.customer.customer_Products?.splice(itemIndex!, 1);
            }
          }
        } else {
          this.$beplugins.ApiError(response);
        }
        this.isLoading = false;
      })
      .catch((error) => {
        console.log(error);
        this.isLoading = false;
      });
  }
}
</script>
<style lang="scss"></style>
